'use strict';

var compareWidget = require('./../../../../../app_storefront_core/cartridge/js/compare-widget'),
	productTile = require('./../../product-tile'),
	progress = require('./../../../../../app_storefront_core/cartridge/js/progress'),
	util = require('./../../util'),
	tls = require('./../../tls'),
	carousel = require('./../../carousel'),
	forceInitRecomm = require('../recommendations'),
	layout = require('./../../layout'),
	position = require('./position'),
	paginationProcessor = require('./paginationProcessor'),
	_ = require('lodash'),
	$cache = {},
	options = {
		dynamicProductsContainer: '.js-search-result-items:last',
		uploadedChunk: false
	};

var loadingPlaceHolderSelector = '.infinite-scroll-placeholder[data-loading-state="unloaded"]',
	loadingTopPlaceHolderSelector = '.infinite-scroll-top-placeholder[data-loading-state="unloaded"]',
	loadedPlaceHolderSelector = '.infinite-scroll-placeholder[data-loading-state="loaded"], .infinite-scroll-top-placeholder[data-loading-state="loaded"]',
	timeOut;

function updateUrl(paramName, paramValue) {
	var url = location.href,
		paramExist = new RegExp("(?:&|\\?)" + paramName + "=(\\w*)"),
		paramReplace = new RegExp(paramName + "=\\w+(?=(&|$))"),
		paramDelete = new RegExp("&" + paramName + "=\\w*|" + paramName + "=\\w*&|\\?" + paramName + "=\\w*$"),
		existSubstr = location.search.match(paramExist),
		state = SitePreferences.LISTING_INFINITE_SCROLL ? {} : $cache.mainWrapper.html();
	if (existSubstr && (existSubstr[1] == "" || existSubstr[1] != paramValue)) {
		history.replaceState(state, "", paramValue ? url.replace(paramReplace, paramName + "=" + paramValue) : url.replace(paramDelete, ""));
	} else if (!existSubstr && paramValue) {
		history.replaceState(state, "", url + (location.search ? "&" : "?") + paramName + "=" + paramValue);
	}
}

function changePageParam() {
	// pagination uses "start" only: "page" overrides it on server (see Search-Show), so it's removed if left from earlier visits
	if (!SitePreferences.LISTING_INFINITE_SCROLL) {
		updateUrl('page', '');
		return;
	}

	var topBorderPosition = !!$cache.topPageElement.length ? $cache.topPageElement.get(0).getBoundingClientRect().bottom : 0,
		bottomBorderPosition = document.documentElement.clientHeight,
		maxDelta = -Infinity,
		currentVisibleElement = 0,
		pageItems = $('.js-search-result-items');
	pageItems.each(function(i) {
		var rect = this.getBoundingClientRect(),
			top = rect.top > topBorderPosition ? rect.top : topBorderPosition,
			bottom = rect.bottom < bottomBorderPosition ? rect.bottom : bottomBorderPosition,
			delta = bottom - top;
		if (delta > maxDelta) {
			maxDelta = delta;
			currentVisibleElement = i;
		}
	});
	var currentPageElement = pageItems.eq(currentVisibleElement),
		pageNumber = Math.floor(currentPageElement.data("pageNumber"));
	updateUrl("page", pageNumber!=1 ? pageNumber : '');
}

/**
 * @private
 * @function
 * @description Remembers the position of the first product visible in the viewport to keep it in place
 * when the content above it changes (see restore()). Changes below don't move it, so nothing is done for them.
 * Works also if the browser keeps the position itself (scroll anchoring): the product doesn't move then.
 * @returns {Object} {restore: Function}
 */
function getScrollAnchor() {
	var tile = null,
		top = 0,
		tiles = document.querySelectorAll('.js-search-result-items .js-product_tile'),
		windowHeight = window.innerHeight;

	for (var i = 0; i < tiles.length; i++) {
		var tileTop = tiles[i].getBoundingClientRect().top;
		if (tileTop >= 0 && tileTop < windowHeight) {
			tile = tiles[i];
			top = tileTop;
			break;
		}
	}

	return {
		restore: function () {
			if (!tile || !document.documentElement.contains(tile)) {
				return;
			}
			var delta = tile.getBoundingClientRect().top - top;
			// ignore tiny shifts to avoid visible jitter
			if (Math.abs(delta) > 1) {
				window.scrollBy(0, delta);
			}
		}
	};
}

/**
 * @private
 * @function
 * @description Keeps the visible products in place for a while after a page is loaded:
 * images, carousels and banners of the loaded page change its height later.
 * The position is taken again on each scroll, so the user scrolling is not reverted.
 */
function keepScrollAnchor() {
	var container = document.querySelector('div.search-result-content');

	if (!window.ResizeObserver || !container) {
		return;
	}

	if (!$cache.anchorKeeper) {
		var anchor = getScrollAnchor(),
			observer = new ResizeObserver(function () {
				anchor.restore();
				anchor = getScrollAnchor();
			});

		observer.observe(container);
		$cache.window.on('scroll.plpanchor', function () {
			anchor = getScrollAnchor();
		});

		$cache.anchorKeeper = {
			stop: function () {
				observer.disconnect();
				$cache.window.off('scroll.plpanchor');
				$cache.anchorKeeper = null;
			}
		};
	}

	clearTimeout($cache.anchorKeeper.timer);
	$cache.anchorKeeper.timer = setTimeout($cache.anchorKeeper.stop, 5000);
}

function loadChunk(loadingPlaceHolder, isTop, isScrollZone) {
	// Start loading products only if we haven't reached the footer zone
	if(!SitePreferences.LISTING_LAZY_INFINITE_SCROLL) {
		if (!isScrollZone) {
			return;
		}
	}

	// get url hidden in DOM
	var gridUrl = loadingPlaceHolder.attr('data-grid-url'),
		start = parseInt(util.getParameterValueFromUrl('start', gridUrl)),
		// loading indicator of the previous page changes the height above the viewport
		anchor = getScrollAnchor();
	// switch state to 'loading'
	// - switches state, so the above selector is only matching once
	// - shows loading indicator
	loadingPlaceHolder.attr('data-loading-state', 'loading');
	loadingPlaceHolder.addClass('infinite-scroll-loading');
	anchor.restore();


	// named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
	var fillEndlessScrollChunk = function (html, isTop) {
		loadingPlaceHolder.removeClass('infinite-scroll-loading');
		loadingPlaceHolder.attr('data-loading-state', 'loaded');
		if (!isTop) {
			html.filter(".infinite-scroll-top-placeholder").attr('data-loading-state', 'loaded');
			$('div.search-result-content').append(html);
		} else {
			html.filter(".infinite-scroll-placeholder").attr('data-loading-state', 'loaded');
			$('div.search-result-content').prepend(html);
		}
		carousel.init({});
		$cache.window.trigger('infinitescroll.loaded');
	};

		var isCategoryUploading = loadingPlaceHolder.attr('data-is-category');
		if (isCategoryUploading === 'true') {
			var toUploadCategories = loadingPlaceHolder.attr('data-upload-categories');
			var originalCategory = loadingPlaceHolder.attr('data-original-categoty-id');
	
			if (!originalCategory) {
				return;
			}
	
			gridUrl = util.appendParamToURL(gridUrl, 'cgid', originalCategory);
	
			if (toUploadCategories) {
				gridUrl = util.appendParamToURL(gridUrl, 'categories', toUploadCategories);
			}
		}

	// old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
	// it was removed to temporarily address RAP-2649

	$.ajax({
		type: 'GET',
		dataType: 'html',
		url: gridUrl,
		success: function (response) {
			var response = $($.parseHTML(response)),
				anchor = getScrollAnchor();
			// put response into cache
			try {
				sessionStorage['scroll-cache_' + gridUrl] = response;
			} catch (e) {
				// nothing to catch in case of out of memory of session storage
				// it will fall back to load via ajax
			}
			// update UI
			initBannerContentSlot(response);
			productTile.init({container: response, start: start});
			fillEndlessScrollChunk(response, isTop);
			// the products the user sees are kept in place: the previous page is added above them,
			// wide banner can be moved to the loaded page, carousels change tiles height
			anchor.restore();
			keepScrollAnchor();

			// Remove previous load more button
			if (SitePreferences.LISTING_LAZY_INFINITE_SCROLL) {
				$(loadedPlaceHolderSelector).find($('.js-load_more_products')).remove();
			}

		}
	});

	
}

function initializeCache() {
	$cache.searchContainer = $('.js-product_search-container');
	$cache.window = $(window);
	$cache.document = $(document);
	$cache.topPageElement = $('.js-sticky-refinements');
	$cache.mainWrapper = $cache.main || $('#main'),
	$cache.pageFooter = $('.b-footer');
}

/**
 * @param {Object} [e] scroll event
 * @param {Boolean} [isRestored] the page is scrolled to the restored position, not to the footer by the user
 */
function infiniteScroll(e, isRestored) {
	changePageParam();
	// getting the hidden div, which is the placeholder for the next page
	var loadingPlaceHolder = $(loadingPlaceHolderSelector),
		loadingTopPlaceHolder = $(loadingTopPlaceHolderSelector),
		topPageElementBottom = (!!$cache.topPageElement.length && $cache.topPageElement.get(0)) ? $cache.topPageElement.get(0).getBoundingClientRect().bottom : 0,
		loaderIndicatorSelector = $('.loader-indicator'),
		scrollSensitivity = SitePreferences.LISTING_INFINITE_SCROLL_SENSITIVITY || 0;
	
	// Detect a zone where infinite loading should stop for a user to access the footer
	var isScrollZoneActive = true,
		isPageBottomReached = $cache.pageFooter.length ? $cache.pageFooter.get(0).getBoundingClientRect().top < $cache.window.height()*0.7 : false,
		isFooterHovered = $cache.pageFooter.is(":hover");

	if (!isRestored && (isPageBottomReached || isFooterHovered)) {
		isScrollZoneActive = false;
	}
	// Start loading when placeholder is in viewport or it has already scrolled up to top,
	// or show "load more" button if lazyInfiniteScroll is on
	// Scrolling down & loading more products
	if (!loaderIndicatorSelector.length && loadingPlaceHolder.length === 1 && (util.elementInViewport(loadingPlaceHolder.get(0), scrollSensitivity) || loadingPlaceHolder.offset().top < $cache.window.scrollTop())) {
		if (SitePreferences.LISTING_LAZY_INFINITE_SCROLL) {
			createLoadMoreLink(loadingPlaceHolder);
		} else {
			loadChunk(loadingPlaceHolder, false, isScrollZoneActive);
		}
	} 
	
	// Scrolling down & loading a new portion of grouped search results
	else if (options.uploadedChunk && loadingPlaceHolder.length === 1 && (util.elementInViewport(loadingPlaceHolder.get(0), scrollSensitivity) || loadingPlaceHolder.offset().top < $cache.window.scrollTop())) {
		if (SitePreferences.LISTING_LAZY_INFINITE_SCROLL) {
			createLoadMoreLink(loadingPlaceHolder);
		} else {
			loadChunk(loadingPlaceHolder, false, isScrollZoneActive);
		}
	} 
	
	// Scrolling up & loading previous pages
	else if (loadingTopPlaceHolder.length === 1 && topPageElementBottom > 0 && topPageElementBottom - loadingTopPlaceHolder.get(0).getBoundingClientRect().top < 50) {
		loadChunk(loadingTopPlaceHolder, true, true);
	}

}

/**
 * @private
 * @function
 * @description Creates "Load more products" link in the loading placeholder
 */
function createLoadMoreLink($loadingPlaceHolder) {
	if($('.js-load_more_products').length) {
		return;
	}

	if ($loadingPlaceHolder.length) {
		var gridUrl = $loadingPlaceHolder.attr('data-grid-url'),
		$loadMoreLink = $('<a/>', {
			href: gridUrl,
			class: "b-button m-transparent b-load-more_products js-load_more_products",
			html: '<span class="b-button-inner">' + Resources.LOAD_MORE_PRODUCTS + '</span>'
		});
			$loadMoreLink.appendTo($loadingPlaceHolder.last());
	}
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
	if (!url || url === window.location.href) {
		return;
	}

	progress.show($('.search-result-content'));

	$cache.mainWrapper.load(util.appendParamToURL(url, 'format', 'ajax'), function (response, status, xhr ) {
		if (xhr.status === 302 && xhr.responseText) {
			try {
					var responseJSON = JSON.parse(xhr.responseText);
					if (responseJSON && responseJSON.redirectUrl) {
							window.location.href = responseJSON.redirectUrl;
					}
			} catch (error) {}
		}
		initBannerContentSlot();
		compareWidget.init();
		productTile.init();
		carousel.init({});
		updateImageViewLinks();
		$(document).trigger('search.update', [{url: url}]);
		progress.hide();
		if (SitePreferences.LISTING_INFINITE_SCROLL) {
			response = null;
		}
		history.pushState(response, '', url);
	});
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
	var $main = $('#main');

	// Disable auto scroll to previous position when user go back to PLP (in case infinity scroll)
	if ('scrollRestoration' in history) {
		history.scrollRestoration = SitePreferences.LISTING_INFINITE_SCROLL ? 'manual' : 'auto';
	}

	// compare checked
	$main.on('click', 'input[type="checkbox"].compare-check', function () {
		var cb = $(this);
		var tile = cb.closest('.js-product_tile');

		var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
		var itemImg = tile.find('.product-image a img').first();
		func({
			itemid: tile.data('itemid'),
			uuid: tile[0].id,
			img: itemImg,
			cb: cb
		});

	});

	// toggle grid view
	$main.on('click', '.js-toggle_grid', function (event) {
		if(event.target.dataset.option === 'wide') {
			$cache.searchContainer.addClass('wide-tiles');
			$(this).addClass('wide');
			updateUrl("viewMode", "wide");
		} else {
			$cache.searchContainer.removeClass('wide-tiles');
			$(this).removeClass('wide');
			updateUrl("viewMode", "");
		}

		initBannerContentSlot();
	});

	// handle events for updating grid
	$main.on('click', '.js-search_update, .refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
		// don't intercept for category and folder refinements, as well as unselectable
		if ($(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
			return;
		}
		e.preventDefault();
		updateProductListing(this.href);
	});

	// handle events item click. append params.
	$main.on('click', '.js-product_tile a:not("#quickviewbutton")', function () {
			var a = $(this);
			// get current page refinement values
			var refinements = a.parents(".js-search-result-content").data('refinements-query');
			var params = refinements ? util.getQueryStringParams(refinements) : {};
			if (!params.start) {
				params.start = 0;
			}
			// get the index of the selected item and save as start parameter
			var tile = a.closest('.js-product_tile');
			var idx = tile.data('idx') ? +tile.data('idx') : 0;

			// convert params.start to integer and add index
			params.start = (+params.start) + (idx + 1);
			// set the hash and allow normal action to continue
			a[0].hash = $.param(params);
			saveListingPosition(tile, params.cgid);
		})
		// browser can keep the URL it had before history.replaceState called right before navigation,
		// so the page of the product is put to URL in advance (see setListingPage)
		.on('mousedown touchend', '.js-product_tile a:not("#quickviewbutton")', function () {
			setListingPage($(this).closest('.js-product_tile'));
		})
		.on('change', '.items-per-page select', function () {
			var refineUrl = $(this).find('option:selected').val();
			if (refineUrl === 'INFINITE_SCROLL') {
				$('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
			} else {
				$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
				updateProductListing(refineUrl);
			}
		})
		.on('click', '.js-load_more_products', function (event) {
			event.preventDefault();
			$(this).remove();
			// infiniteScroll();
			loadChunk($(loadingPlaceHolderSelector), false, true);
		})
		.on('click', '.js-product_view', function (e) {
			e.preventDefault();
			var $viewItem = $(e.target),
				clickedType = $viewItem.data('type');

			writeViewType(clickedType);
			changeImageView(clickedType);
		});

	$(window).on('resize', _.debounce(function () {
		initBannerContentSlot();
	}, 300));

	forceInitRecomm.init();

}

function writeViewType(viewType) {
	var existingTypes = tls.getCookie('viewTypes') || "{}",
		category = pageContext.categoryID;
	if(viewType && category) {
		try {
			existingTypes = JSON.parse(existingTypes);
			existingTypes[category] = viewType;
			tls.setCookie('viewTypes', JSON.stringify(existingTypes),  60 * 24 * 30);
		} catch(e) {
			tls.setCookie('viewTypes', null, -1);
			writeViewType(viewType);
		}
	}
}

function getViewType(category) {
	var existingTypes = tls.getCookie('viewTypes') || "{}",
		result;
	try {
		existingTypes = JSON.parse(existingTypes);
		if(category in existingTypes) {
			result = existingTypes[category];
		}
	} catch(e) {
		result = null;
	}
	return result;
}

/**
 * @private
 * @function
 * @description change image view for product tiles
 */
function changeImageView(viewType) {
	if(!viewType && pageContext.categoryID) {
		viewType = getViewType(pageContext.categoryID)
	}

	if (viewType === 'outfit') {
		$cache.searchContainer.find('.js-product_view-outfit').addClass('m-active').siblings().removeClass('m-active');
		$cache.searchContainer.removeClass('product-view').addClass('outfit-view');
		productTile.loadOutfitImages($cache.searchContainer);
	} else {
		$cache.searchContainer.find('.js-product_view-product').addClass('m-active').siblings().removeClass('m-active');
		$cache.searchContainer.removeClass('outfit-view').addClass('product-view');
	}
}

/**
 * @private
 * @function
 * @description set appropriate link as active according to selected image view
 */
function updateImageViewLinks() {
	$cache.searchContainer
		.find($cache.searchContainer.hasClass('outfit-view') ? '.js-product_view-outfit' : '.js-product_view-product')
		.addClass('m-active')
		.siblings()
		.removeClass('m-active');
}

/**
 * @private
 * @function
 * @description Initialisation inline banners inside products grid
 */
function initInlineContent() {
	function insertInlineContent($inlineBanners, $tilesContainer) {
		var $productTiles = $tilesContainer.find('.js-grid_tile'),
			minPosition = $tilesContainer.data('page-start'),
			ptSize = $productTiles.size();

		$inlineBanners.each(function() {
			var bannerPosition = $(this).data('position') - minPosition;
			if (bannerPosition >= 0 && bannerPosition < ptSize) {
				$(this).insertBefore($productTiles.eq(bannerPosition));
			}
		});
	}

	function updateInlineContent() {
		var $inlineBanners = $('.js-inline-banners').children();
		$cache.window.off('infinitescroll.loaded.inlinecontent');

		if ($inlineBanners.size() > 0) {
			// several pages can be in the grid (e.g. loaded by infinite scroll)
			if (!$('.js-grouped-search-results').length) {
				$('.js-search-result-items').slice(0, -1).each(function () {
					insertInlineContent($inlineBanners, $(this));
				});
			}
			insertInlineContent($inlineBanners, $(options.dynamicProductsContainer));

			$cache.window.on('infinitescroll.loaded.inlinecontent', function(e) {
				insertInlineContent($inlineBanners, $(options.dynamicProductsContainer));
			});
		}
	}

	updateInlineContent();
	$cache.document.on('search.update', updateInlineContent);
}

/**
 * @private
 * @function
 * @description Puts the page of the product to URL: the server renders this page on return from PDP
 * @param {jQuery} $tile product tile
 */
function setListingPage($tile) {
	var $list = $tile.closest('.js-search-result-items'),
		pageNumber = +$list.data('pageNumber') || 1;

	if (SitePreferences.LISTING_INFINITE_SCROLL && $list.length) {
		updateUrl('page', pageNumber !== 1 ? pageNumber : '');
	}
}

/**
 * @private
 * @function
 * @description Remembers the opened product to bring the user back to its row on return from PDP
 * @param {jQuery} $tile clicked product tile
 * @param {String} cgid listing category
 */
function saveListingPosition($tile, cgid) {
	var $list = $tile.closest('.js-search-result-items');

	// tiles outside of the product grid (recommendations, etc.)
	if (!$list.length) {
		return;
	}

	setListingPage($tile);

	// position is restored by script, browser restoration would interfere with it
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	position.save({
		url: location.href,
		cgid: cgid || (window.pageContext && pageContext.categoryID) || null,
		pid: String($tile.attr('data-itemid')),
		index: (+$list.data('pageStart') || 0) + $list.find('.js-product_tile').index($tile),
		offset: $tile.get(0).getBoundingClientRect().top
	});
}

/**
 * @private
 * @function
 * @param {String} pid product ID
 * @returns {jQuery} product tile in the grid
 */
function findTileByProductID(pid) {
	return $('.js-search-result-items .js-product_tile').filter(function () {
		return this.getAttribute('data-itemid') === pid;
	}).first();
}

/**
 * @private
 * @function
 * @description Finds a product tile in the grid by product ID or, if the product is not in the grid anymore,
 * by its position in the listing
 * @param {Object} saved saved position
 * @returns {jQuery}
 */
function findSavedTile(saved) {
	var $tile = findTileByProductID(saved.pid);

	if (!$tile.length) {
		$('.js-search-result-items').each(function () {
			var $list = $(this),
				start = +$list.data('pageStart') || 0,
				$tiles = $list.find('.js-product_tile');

			if (saved.index >= start && saved.index < start + $tiles.length) {
				$tile = $tiles.eq(saved.index - start);
				return false;
			}
		});
	}

	return $tile;
}

/**
 * @private
 * @function
 * @description Scrolls the page to put the tile at the same viewport position it had on click.
 * Keeps the position for a while as images and banners change the layout, until the user starts scrolling.
 * @param {jQuery} $tile
 * @param {Number} offset tile top position relative to viewport
 * @returns {Promise} resolved with the tile
 */
function alignTile($tile, offset) {
	var deferred = $.Deferred(),
		userEvents = 'wheel.plprestore touchstart.plprestore keydown.plprestore mousedown.plprestore',
		attempts = 0,
		maxAttempts = 20,
		userInteracted = false,
		tileHeight = $tile.outerHeight(),
		windowHeight = $cache.window.height();

	// keep the tile visible even if viewport size has changed
	offset = Math.min(Math.max(offset, -tileHeight / 2), windowHeight - tileHeight / 2);

	function align() {
		var delta = $tile.get(0).getBoundingClientRect().top - offset;
		// ignore tiny shifts to avoid visible jitter
		if (Math.abs(delta) > 3) {
			window.scrollBy(0, delta);
		}
	}

	function finish() {
		$cache.document.off(userEvents);
		$cache.window.off('load.plprestore');
		position.log('aligned: tile top', $tile.get(0).getBoundingClientRect().top, 'expected', offset, 'attempts', attempts, 'user interacted', userInteracted);
		deferred.resolve($tile);
	}

	$cache.document.on(userEvents, function () {
		userInteracted = true;
	});
	$cache.window.on('load.plprestore', function () {
		!userInteracted && align();
	});

	(function keepAligned() {
		if (userInteracted || attempts++ >= maxAttempts) {
			finish();
			return;
		}
		align();
		setTimeout(keepAligned, 100);
	})();

	return deferred.promise();
}

/**
 * @private
 * @function
 * @description Brings the user back to the row of products opened before (see saveListingPosition)
 * on "back" navigation or PDP breadcrumb click
 * @returns {Promise} resolved with the restored product tile, if any
 */
function restoreListingPosition() {
	var saved = position.getForRestore();

	if (!saved) {
		return $.Deferred().resolve().promise();
	}

	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	// the product is rendered by server: usually it's already scrolled to before app.js (see search/components/restorepositionend)
	var $renderedTile = findTileByProductID(saved.pid);

	if ($renderedTile.length) {
		position.log('tile', saved.pid, 'is rendered, early restore', window.plpRestoreEarlyDone ? 'done' : 'not done');
		return alignTile($renderedTile, saved.offset);
	}

	// the product is post-loaded or not in the listing anymore
	var listingLoaded = $.Deferred();
	// don't wait for post-loaded products forever (e.g. paging processor is not initialized on a site)
	paginationProcessor.whenLoaded().always(listingLoaded.resolve);
	setTimeout(listingLoaded.resolve, 5000);

	return listingLoaded.then(function () {
		var $tile = findSavedTile(saved);

		position.log('tile', $tile.length ? $tile.attr('data-itemid') : 'not found', 'rendered pages', $('.js-search-result-items').map(function () {
			return $(this).data('pageNumber');
		}).get().join(','));

		return $tile.length ? alignTile($tile, saved.offset) : null;
	});
}

/**
 * @private
 * @function
 * @description Loads the pages next to the restored product row, so the user doesn't wait for them on scrolling:
 * the previous page for the upper half of the page, the next one for the lower half,
 * and any of them which is visible or less than a screen away.
 * Each placeholder is loaded once (see loadChunk), so the page isn't loaded twice on scrolling to it.
 * @param {jQuery} $tile restored product tile
 */
function preloadAdjacentPages($tile) {
	var $tiles = $tile.closest('.js-search-result-items').find('.js-product_tile'),
		isUpperHalf = $tiles.index($tile) < $tiles.length / 2,
		windowHeight = $cache.window.height(),
		$previous = $(loadingTopPlaceHolderSelector),
		$next = $(loadingPlaceHolderSelector),
		// page is visible or less than a screen away, e.g. the end of the page is visible on a tall screen
		isPreviousNear = $previous.length === 1 && $previous.get(0).getBoundingClientRect().bottom > -windowHeight,
		isNextNear = $next.length === 1 && $next.get(0).getBoundingClientRect().top < windowHeight * 2,
		loadPrevious = $previous.length === 1 && (isUpperHalf || isPreviousNear),
		// "load more" button is shown instead of loading of the next page (lazy infinite scroll)
		loadNext = $next.length === 1 && !SitePreferences.LISTING_LAZY_INFINITE_SCROLL && (!isUpperHalf || isNextNear);

	position.log('preload: previous page', loadPrevious ? 'started' : 'skipped', $previous.length ? '' : '(loaded or absent)',
		'next page', loadNext ? 'started' : 'skipped', $next.length ? '' : '(loaded or absent)');

	// the next page is added below the viewport, the previous one keeps the visible products in place (see loadChunk)
	if (loadNext) {
		loadChunk($next, false, true);
	}
	if (loadPrevious) {
		loadChunk($previous, true, true);
	}
}

function initBannerContentSlot($container) {
	$container = $container && $container.filter('.js-search-result-items') || $('.js-search-result-items');
	var $banner = $('.js-plp-wide-slot');

	if ($banner.length) {
		for (var i = 0; i < $container.length; i++) {
			var $currentContainer = $($container[i]);
			var slotPositionConfig = $currentContainer.data('slotsPosition');

			if (slotPositionConfig && slotPositionConfig.showBannerSlot) {
				var skipTiles = slotPositionConfig.position[layout.getMode()];

				if (skipTiles) {
					if ($cache.searchContainer.hasClass('wide-tiles') && !$cache.searchContainer.hasClass('js-skip-wide')) {
						skipTiles = slotPositionConfig.isB2B ? skipTiles - (skipTiles % 4) : skipTiles - (skipTiles % 3);
					}

					if (skipTiles > 0) {
						$currentContainer.children('li:not(".js-plp-wide-slot"):eq(' + --skipTiles + ')').after($banner);
					} else {
						$currentContainer.prepend($banner);
					}

					$banner.removeClass('plp-wide-slot-hidden');

					break;
				}
			}
		}
	}
}

exports.init = function () {
	initializeCache();
	initInlineContent();
	changeImageView();
	initBannerContentSlot();
	compareWidget.init();

	if (SitePreferences.LISTING_INFINITE_SCROLL) {
		// outdated param of position restore, the current page is defined by "page" only
		updateUrl('restore', '');
		$(document).one('upload-products-chunk', function() {
			options.uploadedChunk = true;
		});
	} else {
		history.replaceState($cache.mainWrapper.html(), '', document.location.href);
	}
	productTile.init();
	initializeEvents();
	// "page" URL param updating and loading of next/previous pages start from the restored position only,
	// otherwise scrolling and layout changes during the restore switch "page" and load previous pages above the product
	restoreListingPosition().always(function ($tile) {
		if (SitePreferences.LISTING_INFINITE_SCROLL) {
			$(window).on('scroll', infiniteScroll);
		}
		// the restored position can be close to the footer: load the next page anyway, as on scrolling down to it
		infiniteScroll(null, true);

		if (SitePreferences.LISTING_INFINITE_SCROLL && $tile && $tile.length) {
			preloadAdjacentPages($tile);
		}
	});
};
